<template>
  <div class="container">
    <h1></h1>
    <div class="" v-if="currentTime">
      <h1>
        You have {{ minutes | formatTime }} Minute(s)
        {{ seconds | formatTime }} Second(s) left!
      </h1>
      <!--
      <br />
      <span v-if="days">{{ days }}</span>
      <span v-if="hours" id="timeAndSecond">{{ hours | formatTime }}:</span
      ><span id="timeAndSecond"
        >{{ minutes | formatTime }}:{{ seconds | formatTime }}</span
      ><br />
      -->
    </div>

    <div class="times-up" v-if="!currentTime">Time's Up!</div>
  </div>
</template>

<script>
export default {
  props: {
    deadline: {
      type: Date,
      required: true,
    },
    speed: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      currentTime: Date.parse(this.deadline) - Date.parse(new Date()),
    };
  },
  mounted() {
    setTimeout(this.countdown, 1000);
  },
  computed: {
    seconds() {
      return Math.floor((this.currentTime / 1000) % 60);
    },
    minutes() {
      return Math.floor((this.currentTime / 1000 / 60) % 60);
    },
    hours() {
      return Math.floor((this.currentTime / (1000 * 60 * 60)) % 24);
    },
    days() {
      return Math.floor(this.currentTime / (1000 * 60 * 60 * 24));
    },
  },
  filters: {
    formatTime(value) {
      if (value < 10) {
        return "0" + value;
      }
      return value;
    },
  },
  methods: {
    countdown() {
      this.currentTime = Date.parse(this.deadline) - Date.parse(new Date());
      if (this.currentTime > 0) {
        setTimeout(this.countdown, this.speed);
      } else {
        this.currentTime = null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px 10px;
  margin: 10px;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  border-radius: 8px;
  text-align: center;
  //background-color: chartreuse;
  //min-height: 38vh;

  .times-up {
    font-size: 30px;
  }
}

#timeAndSecond {
  background-color: aqua;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  margin: 0;
}
</style>
